import './App.css';
import Hero from './components/Hero';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Footer from './components/Footer';

function App() {
  return (
    <>
    <Hero />
    <br/>
    <Experience />
    <br/>
    <Projects />
    <br/>
    <Skills />
    <br/>
    <Footer />
    </>
  );
}

export default App;
